import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Form, Spinner, Button } from "react-bootstrap"
import Switch from '@mui/material/Switch'
import { api } from "../../../../../Services/api"
import "react-confirm-alert/src/react-confirm-alert.css"
import { setAllProjects } from "../../../../../redux/Tracking/actionCreator"
import { v4 as uuid } from "uuid"
import MydashboardModalView from "./style"
import ProgressBar from "react-bootstrap/ProgressBar"
import EditIcon from "../../../../../../src/assets/images/icons/noun-edit-3556018.svg"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import { normalizeNumber } from "../../../../../Utilities/commonFunctions"
import UIModal from "../../../../Reuseable/Modal"

export default function ProjectEditableComponents({ showProject, permission, datas, allProjects }) {
  let data = datas
  const editPermission = permission?.edit

  const dispatch = useDispatch()
  const authToken = useSelector((state) => state.Auth.authToken)
  const [searchValue, setSearchValue] = useState("")
  const [loading, setLoading] = useState(false)
  const trackingClientId = useSelector((state) => state.Auth.user.trackingclientid)
  let allWorkFlow = useSelector((state) => state.Tracking.allWorkFlow)
  let allProjectDashboard = useSelector((state) => state.Tracking.allProjectDashboard)
  let Work_Flow = Object.keys(allWorkFlow).map((key) => allWorkFlow[key])
  const [showEditTask, setShowEditTask] = useState("")
  const [projectBudget, setProjectBudget] = useState({})
  const [projectBudgetUpdate, setProjectBudgetUpdate] = useState({})
  const [showBacklogsModal, setShowBacklogsModal] = useState(false)
  const [pendingBacklogsValue, setPendingBacklogsValue] = useState(null)
  let projectNow = allProjects?.find((item) => item.trackingprojectid === data)
  const getTuDApprovals = (val) => {
    if (typeof val === 'boolean') return val
    if (typeof val === 'string') {
      return val.toLowerCase() === 'true' || val.toLowerCase() === 'yes'
    }
    return false
  }
  const [isTudEnabled, setIsTudEnabled] = useState(
    getTuDApprovals(projectNow?.istudenabled)
  );

  const handleTudChange = (e) => {
    const newValue = e.target.checked;
    setIsTudEnabled(newValue);
    updateTask("istudenabled", newValue); // keep your existing logic
  };

  const getTcdApprovals = (val) => {
    if (typeof val === "boolean") return val;
    if (typeof val === "string") {
      return val.toLowerCase() === "true" || val.toLowerCase() === "yes";
    }
    return false;
  };

  // Local state for TCD toggle
  const [isTcdEnabled, setIsTcdEnabled] = useState(
    getTcdApprovals(projectNow?.istcdenabled)
  );

  // Handle toggle change
  const handleTcdChange = (e) => {
    const newValue = e.target.checked;
    setIsTcdEnabled(newValue);
    updateTask("istcdenabled", newValue);
  };


  const titleRef = useRef()
  const index = allProjects?.findIndex(
    (element) => element.trackingprojectid === projectNow?.trackingprojectid
  )

  // Helper to normalize isbacklogs value from API
  const getIsBacklogsSwitch = (val) => {
    if (typeof val === 'boolean') return val
    if (typeof val === 'string') {
      return val.toLowerCase() === 'true' || val.toLowerCase() === 'yes'
    }
    return false
  }



  useEffect(() => {
    setProjectBudget((prevState) => {
      return {
        ...prevState,
        budget: projectNow?.budget
      }
    })
    setProjectBudgetUpdate((prevState) => {
      return {
        ...prevState,
        budget: projectNow?.budget
      }
    })
  }, [projectNow])

  const Work_Flow1 = Object.values(allWorkFlow).flatMap((obj) => Object.values(obj))

  let workflow_status = Work_Flow1.find((e) => e.workFlowId === allProjectDashboard.workflowid)
  const statusName = workflow_status?.workFlow
  allProjectDashboard.workflow_status = statusName ? Object.values(statusName) : ""

  const handleSplChar = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      editItem("budget")
      updateTask("budget", projectBudgetUpdate.budget)
      setShowEditTask((prevState) => {
        return { ...prevState, editTitle: false }
      })
    }
    if (
      e.key === "#" ||
      e.key === "$" ||
      e.key === "^" ||
      e.key === "@" ||
      e.key === "*" ||
      e.key === "(" ||
      e.key === "!" ||
      e.key === ")" ||
      e.key === "%" ||
      e.key === "="
    ) {
      e.preventDefault()
    }
  }

  const editIconCSS = {
    marginLeft: "3%",
    cursor: "pointer",
    marginTop: "1%"
  }

  const tickCloseIconCSS = {
    fontSize: "17px",
    marginTop: "-2px",
    marginLeft: "1%"
  }

  const editItem = (item) => {
    if (item === "budget")
      setShowEditTask((prevState) => {
        return { ...prevState, editTitle: true }
      })
  }

  const updateTask = async (name, value) => {
    let Obj = {
      label: projectNow.label,
      projectdescription: projectNow.projectdescription,
      startdate: projectNow.startdate,
      duedate: projectNow.duedate,
      createdby: projectNow.createdby,
      priority: projectNow.priority,
      budget: name === "budget" ? value : projectNow.budget,
      percentage: projectNow.percentage,
      workflow: projectNow.workflow,
      teammates: projectNow.teammates,
      isPriority: projectNow.isPriority ? projectNow.isPriority : false,
      fileurls: projectNow.fileurls,
      versionlist: projectNow.versionlist ? projectNow.versionlist : [],
      isbacklogs: name === "isbacklogs" ? value : (projectNow.backlogs !== undefined ? projectNow.backlogs : projectNow.isbacklogs),
      istaskapproval: name === "istaskapproval" ? value : (projectNow.istaskapproval !== undefined ? projectNow.istaskapproval : false),
      istudenabled: name === "istudenabled" ? value : (projectNow.istudenabled !== undefined ? projectNow.istudenabled : false),
      istcdenabled: name === "istcdenabled" ? value : (projectNow.istcdenabled !== undefined ? projectNow.istcdenabled : false),
    }

    // For budget, only patch if value is truthy (as before)
    // For isbacklogs, allow both true/false
    if ((name === "budget" && value) || name === "isbacklogs" || name === "istaskapproval" || name === "istudenabled" || name === "istcdenabled") {
      setLoading(true)
      api
        .patch("/trackingprojects/" + trackingClientId + "/" + projectNow.trackingprojectid, Obj, {
          headers: {
            authorizationtoken: `${authToken}`
          }
        })
        .then(function (response) {
          setLoading(false)
          if (response.status === 200) {
            if (index !== -1 || index === 0) {
              allProjects[index][name] = value
              let newObj = [...allProjects]
              dispatch(setAllProjects(newObj))
            }
          }
        })
        .catch((error) => {
          setLoading(false)
          console.error(error)
        })
    }
  }

  return (
    <>
      <MydashboardModalView>
        <div className='budget_timeline three-cards'>
          {/* <div className='project_budget card-shrink'>
            <h5 className='project_sub_head'>Budget</h5>
            <div className='budget_inside'>
              {showEditTask && showEditTask.editTitle ? (
                <div className='d-flex edit-content trackingdatarow'>
                  <Form.Control
                    type='text'
                    className='p-0 select-options'
                    ref={titleRef}
                    value={projectBudgetUpdate?.budget}
                    onChange={(e) =>
                      setProjectBudgetUpdate((prevState) => {
                        return { ...prevState, budget: normalizeNumber(e.target.value) }
                      })
                    }
                    onKeyDown={handleSplChar}
                  />
                  <div
                    className='ms-2 text-center edit-cross'
                    onClick={(e) => {
                      setShowEditTask((prevState) => {
                        return { ...prevState, editTitle: false }
                      })
                      updateTask("budget", projectBudgetUpdate?.budget)
                    }}
                  >
                    <CheckIcon style={tickCloseIconCSS} />
                  </div>
                  <div
                    className='ms-2 text-center edit-cross'
                    onClick={(e) => {
                      setShowEditTask((prevState) => {
                        return { ...prevState, editTitle: false }
                      })
                      setProjectBudgetUpdate((prevState) => {
                        return {
                          ...prevState,
                          budget: projectNow?.budget
                        }
                      })
                    }}
                  >
                    <CloseIcon style={tickCloseIconCSS} />
                  </div>
                </div>
              ) : (
                <span className='edit-content'>
                  {projectNow?.budget ? (
                    <h1 className='m-0 h_budget'>${projectNow?.budget}</h1>
                  ) : (
                    "0"
                  )}

                  {loading && <div className="ms-2"><Spinner animation='border' variant='info' /></div>}

                  {editPermission && !loading && (
                    <img
                      src={EditIcon}
                      alt='editIcon'
                      height={17}
                      width={17}
                      style={editIconCSS}
                      onClick={(e) => editItem("budget")}
                    />
                  )}
                </span>
              )}
            </div>
          </div> */}

          {console.log(projectNow, "projectNow")}

          <div className='project_timeline card-shrink'>
            <h5 className='project_sub_head'>Time line</h5>
            <div className='timeline_inside'>
              <div className='timeline_head'>
                <p>Due date {projectNow?.duedate}</p>
                <p>{projectNow?.percentage}%</p>
              </div>
              <ProgressBar now={projectNow?.percentage} />
            </div>
          </div>


          <div className='project_extra card-shrink' >
            <div className='extra_inside'>
              <div style={{ display: 'flex', alignItems: 'center', minWidth: 220, maxWidth: '100%' }}>
                <Switch
                  id="move-all-tasks-backlogs-switch"
                  color="primary"
                  checked={getIsBacklogsSwitch(projectNow?.isbacklogs ?? projectNow?.backlogs)}
                  onChange={(e) => {
                    setPendingBacklogsValue(e.target.checked)
                    setShowBacklogsModal(true)
                  }}
                  sx={{
                    transform: 'scale(1.5)',
                    marginRight: 1,
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#4EB6EE',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#4EB6EE',
                    },
                  }}
                  disabled={loading}
                />
                <span style={{ fontSize: 16, color: 'white', marginLeft: 8 }}>
                  {getIsBacklogsSwitch(projectNow?.isbacklogs ?? projectNow?.backlogs)
                    ? 'Move all the tasks to Backlogs'
                    : 'Move all the tasks to Backlogs'}
                </span>
              </div>
            </div>
          </div>

          <div className='project_extra card-shrink'>
            <div className='extra_inside'>
              <div style={{ display: 'flex', alignItems: 'center', minWidth: 220, maxWidth: '100%' }}>
                <Switch
                  id="enable-task-approvals-switch"
                  color="primary"
                  checked={getIsBacklogsSwitch(projectNow?.istaskapproval)}
                  onChange={(e) => {
                    updateTask("istaskapproval", e.target.checked);
                  }}
                  sx={{
                    transform: 'scale(1.5)',
                    marginRight: 1,
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#4EB6EE',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#4EB6EE',
                    },
                  }}
                  disabled={loading}
                />
                <span style={{ fontSize: 16, color: 'white', marginLeft: 8 }}>
                  {getIsBacklogsSwitch(projectNow?.istaskapproval)
                    ? 'Enable task Approvals'
                    : 'Enable task Approvals'}
                </span>
              </div>
            </div>
          </div>

          <div className='project_extra card-shrink'>
            <div className='extra_inside'>
              <div style={{ display: 'flex', alignItems: 'center', minWidth: 220, maxWidth: '100%' }}>
                <Switch
                  id="move-all-tasks-tud-switch"
                  color="primary"
                  checked={isTudEnabled}
                  onChange={handleTudChange}
                  sx={{
                    transform: 'scale(1.5)',
                    marginRight: 1,
                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#4EB6EE' },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#4EB6EE',
                    },
                  }}
                  disabled={loading}
                />

                <span title={"Document Of Understanding"} style={{ fontSize: 16, color: 'white', marginLeft: 8 }}>
                  {getTuDApprovals(projectNow?.istudenabled ?? projectNow?.istudenabled)
                    ? 'Enable DOU '
                    : 'Enable DOU '}
                </span>
              </div>
            </div>
          </div>

          <div className="project_extra card-shrink">
            <div className="extra_inside">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: 220,
                  maxWidth: "100%",
                }}
              >
                <Switch
                  id="move-all-tasks-tcd-switch"
                  color="primary"
                  checked={isTcdEnabled}
                  onChange={handleTcdChange}
                  sx={{
                    transform: "scale(1.5)",
                    marginRight: 1,
                    "& .MuiSwitch-switchBase.Mui-checked": { color: "#4EB6EE" },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4EB6EE",
                    },
                  }}
                  disabled={loading}
                />

                <span style={{ fontSize: 16, color: "white", marginLeft: 8 }}>
                  {getTcdApprovals(projectNow?.istcdenabled)
                    ? "Enable Test cases"
                    : "Enable Test cases"}
                </span>
              </div>
            </div>
          </div>


          {/* Modal for confirmation - styled to match other pages */}
          <UIModal
            showModal={showBacklogsModal}
            setShowModal={setShowBacklogsModal}
            size="md"
            forBacklogsModel={true}
          >
            <div className="text-center">
              <p className="mb-4 backlogs_move_content">
                {pendingBacklogsValue
                  ? "You are about to change the default setting. Are you sure you want to proceed?"
                  : "You are about to change the default setting. Are you sure you want to proceed?"}
              </p>
              <button
                className="backlogs_go_btn"
                onClick={() => {
                  setShowBacklogsModal(false)
                  updateTask("isbacklogs", pendingBacklogsValue)
                }}
                disabled={loading}
              >
                Yes, proceed
              </button>
              <button
                className="backlogs_go_btn"
                style={{ marginLeft: 10, background: "#ccc", color: "#333" }}
                onClick={() => setShowBacklogsModal(false)}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </UIModal>

        </div>
      </MydashboardModalView>
    </>
  )
}
